import { Country } from '../types/country';
import { Device } from '@capacitor/device';

export const getCountryFromLanguage = async (): Promise<Country> => {
  const deviceCountry = await Device.getLanguageTag();
  const parts = deviceCountry.value.split('-');
  const languageCode = parts[0];
  const regionCode = parts[1];

  if (regionCode) {
    const fullLocale = `${languageCode}-${regionCode.toUpperCase()}`;

    switch (fullLocale) {
      case 'fr-FR':
        return Country.FRANCE;
      case 'fr-BE':
        return Country.BELGIUM;
      case 'fr-CH':
        return Country.SWITZERLAND;
      case 'fr-CA':
        return Country.FRANCE;
      case 'en-GB':
      case 'en-UK':
        return Country.ENGLAND;
      case 'en-US':
        return Country.UNITED_STATES;
      case 'en-AU':
        return Country.AUSTRALIA;
      case 'en-CA':
        return Country.ENGLAND;
      case 'en-IN':
        return Country.INDIA;
      case 'es-ES':
        return Country.SPAIN;
      case 'pt-PT':
        return Country.PORTUGAL;
      case 'pt-BR':
        return Country.BRAZIL;
      case 'it-IT':
        return Country.ITALY;
      case 'de-DE':
        return Country.GERMANY;
      case 'de-AT':
        return Country.AUSTRIA;
      case 'de-CH':
        return Country.SWITZERLAND;
      default:
        switch (regionCode.toUpperCase()) {
          case 'CH':
            return Country.SWITZERLAND;
          case 'FR':
            return Country.FRANCE;
          case 'ES':
            return Country.SPAIN;
          case 'BE':
            return Country.BELGIUM;
          case 'BR':
            return Country.BRAZIL;
          case 'PT':
            return Country.PORTUGAL;
          case 'GB':
          case 'UK':
            return Country.ENGLAND;
          case 'US':
            return Country.UNITED_STATES;
          case 'AU':
            return Country.AUSTRALIA;
          case 'IN':
            return Country.INDIA;
          case 'IT':
            return Country.ITALY;
          case 'DE':
            return Country.GERMANY;
          case 'AT':
            return Country.AUSTRIA;
          default:
            break;
        }
    }
  }

  switch (languageCode) {
    case 'fr':
      return Country.FRANCE;
    case 'en':
      return Country.ENGLAND;
    case 'es':
      return Country.SPAIN;
    case 'pt':
      return Country.BRAZIL;
    case 'it':
      return Country.ITALY;
    case 'de':
      return Country.GERMANY;
    default:
      return Country.ENGLAND;
  }
};
